import { useState } from 'react';

const DEFAULT_INPUT_STATE = {
  inputValue: '',
  inputRows: 1
};
const ROW_COUNT = 8;
const SPLITTER = /[,\s]+/;

const useSurveyParticipantsInput = () => {
  const [inputValue, setInputValue] = useState(DEFAULT_INPUT_STATE.inputValue);
  const [inputRows, setInputRows] = useState(DEFAULT_INPUT_STATE.inputRows);

  const handleChange = (event) => {
    event.preventDefault();
    const value = event.target.value || DEFAULT_INPUT_STATE.inputValue;
    const rows = value.split(SPLITTER).length > 1 ? ROW_COUNT : 1;
    setInputValue(value);
    setInputRows(rows);
  };

  const resetInput = () => {
    setInputValue(DEFAULT_INPUT_STATE.inputValue);
    setInputRows(DEFAULT_INPUT_STATE.inputRows);
  };

  const splitInputValue = () =>
    [...new Set(inputValue.split(SPLITTER).map((s) => s.trim()).filter((s) => s.length))];

  return {
    inputValue,
    inputRows,
    handleChange,
    resetInput,
    splitInputValue
  };
};

export default useSurveyParticipantsInput;
